import type { LocaleCode } from "../types/locale-code";
import type { LocaleConsent } from "../types/locale-consent";

// Consent shapes are enforced here via LocaleConsent + satisfies; registry init
// does not re-validate these fields (see validate-locale-registry.ts).
const DEFAULT_CATEGORY_CONFIG: LocaleConsent["categoryConfig"] = {
  ANALYTICS: "DENY",
  ESSENTIAL: "ACCEPT",
  MARKETING: "DENY",
  OPT_OUT: "DENY",
  PERSONALIZATION: "DENY",
  STORAGE: "ACCEPT",
};
const DEFAULT_OSANO_PRODUCTION_CONFIG_ID =
  "36ef9a9f-29e7-4c87-824a-bf2a4e1a26f4";
const OSANO_CUSTOMER_ID = "AzykY1ThHLkaH2Tqr";
const OSANO_IE_PRODUCTION_CONFIG_ID = "d78510ec-2e9a-43ed-a4ce-18593edc0262";

const LOCALE_CONSENT_CONFIG_BY_CODE = {
  "ca-en": {
    categoryConfig: DEFAULT_CATEGORY_CONFIG,
    osanoConfigId: DEFAULT_OSANO_PRODUCTION_CONFIG_ID,
    osanoCustomerId: OSANO_CUSTOMER_ID,
  },
  "ie-en": {
    categoryConfig: DEFAULT_CATEGORY_CONFIG,
    osanoConfigId: OSANO_IE_PRODUCTION_CONFIG_ID,
    osanoCustomerId: OSANO_CUSTOMER_ID,
  },
  "us-en": {
    categoryConfig: DEFAULT_CATEGORY_CONFIG,
    osanoConfigId: DEFAULT_OSANO_PRODUCTION_CONFIG_ID,
    osanoCustomerId: OSANO_CUSTOMER_ID,
  },
} as const satisfies Record<LocaleCode, LocaleConsent>;

export { LOCALE_CONSENT_CONFIG_BY_CODE };
